import { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
// import { useNavigate } from 'react-router-dom'
import Arrow from 'components/Common/MasterComponents/Select/Arrow'
import FlagIcon from 'components/Common/FlagIcon'
import useClickOutside from 'utils/hooks/useClickOutside'
import {
  Anchor,
  FlagWrapper,
  Item,
  ItemAdd,
  Label,
  List,
  Wrapper,
} from './_styles'
import InputLoading from 'components/Common/MasterComponents/Input/InputLoading'
import { useTechSheetsList } from 'components/Pages/Wine/View/Common/ViewPdf/_methods'
import type { TechSheet } from 'components/Pages/Wine/View/Common/ViewPdf/_methods/useTechSheetsList'
// import { getWineEditUrl } from 'utils/wine'

interface SelectProps {
  onSelectLang?: (localeId: number) => void
  loading?: boolean
  productId: string
  staticTechSheets?: TechSheet[]
}

const Select = (props: SelectProps) => {
  const { onSelectLang, loading, productId, staticTechSheets } = props

  const { t } = useTranslation()

  const {
    // wineId,
    techSheets: fetchedTechSheets,
    totalLocalesCount,
  } = useTechSheetsList(staticTechSheets ? null : productId)
  const techSheets = staticTechSheets ?? fetchedTechSheets
  const showAddButton =
    !staticTechSheets && totalLocalesCount > techSheets.length

  const [opened, setOpened] = useState(false)
  const wrapperRef = useRef<HTMLDivElement>(null)

  useClickOutside(wrapperRef, () => setOpened(false))

  const handleSelectLang = (localeId: string | number) => {
    setOpened(false)
    onSelectLang?.(Number(localeId))
  }

  const toggleList = () => {
    if (loading) {
      setOpened(false)
    } else {
      setOpened(prev => !prev)
    }
  }

  // const navigate = useNavigate()
  const handleAddLanguage = () => {
    // navigate(getWineEditUrl(wineId, 'techsheets'))
  }

  return (
    <Wrapper ref={wrapperRef}>
      <Anchor data-testid='wine-public-techsheet-select' onClick={toggleList}>
        <Label>{t('wine.view.techsheet.viewPdf')}</Label>
        {loading ? <InputLoading /> : <Arrow opened={opened} />}
      </Anchor>

      {opened && (
        <List>
          {techSheets.map((item: TechSheet) => (
            <Item
              key={item.id}
              data-testid={`wine-public-techsheet-option-${item.id}`}
              onClick={() => handleSelectLang(item.localeId)}
            >
              <FlagWrapper>
                <FlagIcon codeISO={item.locale} size={24} />
              </FlagWrapper>
              {item.name}
            </Item>
          ))}

          {showAddButton && (
            <ItemAdd
              data-testid='wine-public-techsheet-add-language'
              onClick={handleAddLanguage}
            >
              + {t('wine.view.techsheet.addLanguage')}
            </ItemAdd>
          )}
        </List>
      )}
    </Wrapper>
  )
}

export default Select
